module.exports = __webpack_public_path__ + "static/images/error.a5208847d3ecb6e9519e53b62a4fb5c7.svg";